import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICompanyInfoState } from '../reducers/company-info.reducer';
import { DbStoreState } from '../reducers';

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getCompanyInfoState = createSelector(
  getDbStoreState,
  (dbStoreState: DbStoreState) => dbStoreState.companyInfo
);

export const getCompanyInfo = createSelector(
  getCompanyInfoState,
  (state: ICompanyInfoState) => state.companyInfo
);

export const getCompanyInfoLoaded = createSelector(
  getCompanyInfoState,
  (state: ICompanyInfoState) => state.loaded
);

export const getCompanyInfoLoading = createSelector(
  getCompanyInfoState,
  (state: ICompanyInfoState) => state.loading
);

export const getPaymentProviderConnected = createSelector(
  getCompanyInfo,
  (companyInfo) => companyInfo?.payment_provider?.connected || false
);

export const getPaymentProvider = createSelector(
  getCompanyInfo,
  (companyInfo) => companyInfo?.payment_provider?.provider || null
);

export const hasPaymentSetup = createSelector(
  getCompanyInfo,
  (companyInfo) =>
    companyInfo?.payment_provider?.connected &&
    companyInfo?.payment_provider?.provider !== null
);